import { render, staticRenderFns } from "./CadastroConfiguracao.vue?vue&type=template&id=3054f185"
import script from "./CadastroConfiguracao.vue?vue&type=script&lang=js"
export * from "./CadastroConfiguracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports